const language = {
	spanish: {
		contact_title: "¿Tienes alguna pregunta?",
		contact_text:
			"Obtén información sobre precios y detalles de nuestras soluciones.",
		contact_button_1: "CONTACTA A VENTAS",
		contact_button_2: "CENTRO DE SOPORTE",
	},
	english: {
		contact_title: "¿Do you have any questions?",
		contact_text: "Get pricing information and details of our solutions.",
		contact_button_1: "CONTACT SALES",
		contact_button_2: "SUPPORT CENTER",
	},
};

export default language;